import CIcon from "@coreui/icons-react";
import { CButton } from "@coreui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useUser } from "reactfire";
import { BasicCollapse, BasicInput, StyledTextArea } from "src/components";
import SingleInput from "src/components/SingleInput/SingleInput";
import { useEsgEmails } from "src/features/esg-survey/hooks";
import { selectOrgData } from "src/store/projectSelectors";
import { isRequired } from "src/utils/validationOptions";

const ContactForm = () => {
  const form = useForm();

  const orgData = useSelector(selectOrgData);
  const { data: user } = useUser();

  useEffect(() => {
    if (!orgData) return;
    form.reset({
      name: user?.displayName || "",
      organisation: orgData?.orgName,
      email: orgData?.email,
    });
  }, [orgData, user]);

  const onChange = (e) => {
    form.setValue(e.target.name, e.target.value, { shouldTouch: true });
  };

  const { errors, touchedFields } = form.formState || {};

  const isTouched = Object.keys(touchedFields).length > 0;

  const values = form.getValues();

  const { sendEsgContactEmail } = useEsgEmails();

  const [sending, setSending] = useState(false);

  useEffect(() => {
    form.register("name", isRequired);
    form.register("organisation", isRequired);
    form.register("email", isRequired);
    form.register("message", isRequired);
  }, []);

  const onSubmit = async () => {
    const isValid = await form.trigger();
    if (!isValid) return;
    const values = form.getValues();

    try {
      setSending(true);
      await sendEsgContactEmail(values);
    } catch (error) {
      console.log("error", error);
    } finally {
      setSending(false);
    }
  };

  return (
    <BasicCollapse
      className="bg-light mt-2 rounded text-black"
      title={"Contact Us"}
    >
      <div
        className="p-3 d-flex flex-column"
        style={{
          gap: "1rem",
        }}
      >
        <p>
          If you need strategic or technical support for any improvement plans,
          please fill out the form below and we'll be in touch.
        </p>
        <SingleInput
          label="Name"
          Component={BasicInput}
          name="name"
          {...{ onChange, values, errors }}
        />
        <SingleInput
          label="Organisation"
          Component={BasicInput}
          name="organisation"
          {...{ onChange, values, errors }}
        />
        <SingleInput
          label="Email"
          Component={BasicInput}
          name="email"
          {...{ onChange, values, errors }}
        />
        <SingleInput
          label="Message"
          Component={StyledTextArea}
          rows={2}
          name="message"
          {...{ onChange, values, errors }}
        />
        <div className="d-flex justify-content-center ">
          <CButton
            type="button"
            size="lg"
            color="success"
            disabled={!isTouched || sending}
            onClick={onSubmit}
          >
            <CIcon name="cil-send" className="mr-2" />
            {sending ? "Sending..." : "Send email"}
          </CButton>
        </div>
      </div>
    </BasicCollapse>
  );
};

export default ContactForm;
